import { getFaqSections } from '@/services/FaqsService'

import { isError } from '../../utils/api'
import { getFaqQuestions } from '../../services/FaqsService'

export default {
  state: {
    sections: [],
    questions: []
  },

  mutations: {
    setFaqSections(state, sections) {
      state.sections = sections
    },
    setFaqQuestions(state, questions) {
      state.questions = questions
    }
  },

  actions: {
    async getFaqSections({ commit }) {
      const response = await getFaqSections().catch(e => e.response)
      if (!isError(response.status)) {
        // Put 'Contact' section in first place
        var tempSections = response.data
        var contactSection = tempSections.filter(e => e.name === 'Contact')
        tempSections = tempSections.filter(e => e.name !== 'Contact')
        tempSections.unshift(contactSection[0])
        commit('setFaqSections', tempSections)
      } else {
        // TODO: revise this case
      }
    },
    async getFaqQuestions({ commit }, sectionId) {
      const response = await getFaqQuestions(sectionId).catch(e => e.response)
      if (!isError(response.status)) {
        commit('setFaqQuestions', response.data.data)
      } else {
        // TODO: revise this case
      }
    },
    clearQuestions({ commit }) {
      commit('setFaqQuestions', [])
    }
  }
}
